module.exports = __webpack_public_path__ + "static/media/automacao.26eaa604.svg";